import Vue from 'vue'
import VueRouter from 'vue-router'
import { WhiteList } from '../const/const'
import { session } from '../utils/storage'

import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Page404 from '../views/Page404.vue'
import UserIndex from '../views/user/Index.vue'
import Info from '../views/user/Info.vue'
import Import from '../views/user/Import.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/user',
    name: 'User',
    component: UserIndex,
    children: [
      {
        path: 'info',
        name: 'Info',
        component: Info,
      },
      {
        path: 'import',
        name: 'Import',
        component: Import,
      },
      { path: '*', component: Page404 }
    ]
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }, 
  {
    path: '*',
    component: Page404
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  router.app.$store.commit('recevieRouter', to.fullPath);
  let accessToken = session.get("access_token");
  if(accessToken != null) {
    if (to.name === 'Login') next({ name: 'Home' }); else next();
  } else {
    if (WhiteList.indexOf(to.name) == -1) {
      next({ name: 'Login', query: { redirect: to.fullPath }})
    } else {
      next()
    }
  }
})

export default router
